import { blockLearners, requiresAuth, requiresTerms } from "@/middleware";

const GradebookView = () => import("./GradebookView.vue");
const GradebookSelectionView = () => import("./GradebookSelectionView.vue");

const gradebookRoutes = [
  {
    path: "/gradebook",
    name: "GradebookSelection",
    component: GradebookSelectionView,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockLearners]
    }
  },
  {
    path: "/gradebook/:id",
    name: "Gradebook",
    component: GradebookView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockLearners]
    }
  }
];

export default gradebookRoutes;
